import {
  text,
  headline,
  spacer,
  image,
  survey,
  button,
  field,
} from '@components/Widgets/_contentItems/all'
import { settings, styling } from '@components/Widgets/Templates/_base'
import {
  position,
  trigger,
  type,
  maxWidth,
  animation,
} from '@meta/widget/options.js'
import { tag, typeTag } from '@meta/widget/templates'
import themes from '@components/Widgets/Templates/Themes/all'

const info = {
  name: 'Mystery Gift',
  templateID: '2',
  description: 'Create excitement and curiosity with the "Mystery Gift" widget. Users can enter their email for a chance to receive a surprise gift, making it a fun way to engage and reward your audience.',
  tags: [typeTag.POPUP, tag.CUSTOMER_SEGMENTATION, tag.COUPONS_OFFERS],
}

const json = {
  id: 3424574,
  templateID: info.templateID,
  type: type.COLUMN,
  name: info.name,
  theme: themes.BLACK_YELLOW,
  active: true,
  settings: (() => {
    const customSettings = { ...settings }
    customSettings.trigger = trigger.RIBBON
    customSettings.position = position.CENTER
    customSettings.animation = animation.ZOOM
    customSettings.ribbonColor = 'rgba(254, 254, 254, 1)'
    customSettings.closeButtonColor = 'rgb(24,24,24)'
    return customSettings
  })(),
  styling: (() => {
    const customStyling = { ...styling }
    customStyling.maxWidth = maxWidth.MEDIUM
    customStyling.borderRadius = '40px'
    customStyling.backgroundSize = 'cover'
    customStyling.backgroundColor = 'rgb(255, 230, 140)'
    return customStyling
  })(),
  steps: [
    {
      id: '3p0vatm',
      contentItems: [
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/mystery_ribbon_top.png'
          Object.assign(customImage.styling, {
            backgroundSize: 'cover',
            backgroundColor: 'rgba(70, 88, 61, 0)',
            backgroundPosition: 'center',
          })
          return customImage
        })(),
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/mystery_gift.png'
          Object.assign(customImage.styling,
            { backgroundSize: 'cover', backgroundPosition: 'center' })
          return customImage
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '10px' })
          return customSpacer
        })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'You\'ve Got a Mystery Gift'
          Object.assign(customHeadline.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '32px',
            textAlign: 'center',
            fontFamily: 'Anton',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = '<p>To claim your discount, tell us who you\'re shopping for</p>'
          Object.assign(customText.styling, {
            color: 'rgb(24,23,26)',
            fontSize: '20px',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '12px' })
          return customSpacer
        })(),
        (() => {
          const customSurvey = JSON.parse(JSON.stringify(survey))
          customSurvey.content.options = [
            { id: 'k5rj2hy', text: 'Myself' },
            { id: '9sheias', text: 'Someone Else' },
          ]
          Object.assign(customSurvey.styling, {
            color: 'rgb(0, 0, 0)',
            fontSize: '20px',
            textAlign: 'center',
            fontFamily: 'Anton',
            fontWeight: '400',
            borderColor: 'rgba(0, 0, 0, 1)',
            borderWidth: '0px',
            borderRadius: '20px',
            backgroundColor: 'rgb(254,254,254)',
          })
          customSurvey.settings.label = 'Consumer target'
          customSurvey.settings.required = true
          return customSurvey
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Continue'
          Object.assign(customButton.styling, {
            color: 'rgb(254,254,254)',
            fontSize: '18px',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgb(0, 0, 0)',
            borderWidth: '0px',
            borderRadius: '0px',
            justifyContent: 'center',
            backgroundColor: 'rgb(24, 23, 26)',
          })
          customButton.settings.backBtn = false
          return customButton
        })(),
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/mystery_ribbon_bottom.png'
          Object.assign(customImage.styling, {
            backgroundSize: 'cover',
            backgroundColor: 'rgba(230, 232, 229, 0)',
            backgroundPosition: 'center',
          })
          return customImage
        })(),
      ],
    },
    {
      id: '4xph41x',
      contentItems: [
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/mystery_ribbon_top.png'
          Object.assign(customImage.styling, {
            backgroundSize: 'cover',
            backgroundColor: 'rgba(70, 88, 61, 0)',
            backgroundPosition: 'center',
          })
          return customImage
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '25px' })
          return customSpacer
        })(),
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/mystery_gift.png'
          Object.assign(customImage.styling,
            { backgroundSize: 'cover', backgroundPosition: 'center' })
          return customImage
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '10px' })
          return customSpacer
        })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Enjoy "Prize"'
          Object.assign(customHeadline.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '32px',
            textAlign: 'center',
            fontFamily: 'Anton',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = '<p>Enter your email to claim </p><p>your mystery gift!</p>'
          Object.assign(customText.styling, {
            color: 'rgb(24,23,26)',
            fontSize: '20px',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '12px' })
          return customSpacer
        })(),
        (() => {
          const customField = JSON.parse(JSON.stringify(field))
          customField.content.placeholder = 'Your Email Address'
          Object.assign(customField.styling, {
            color: 'rgb(0, 0, 0)',
            fontSize: '18px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: '#000000',
            borderWidth: '0px',
            borderRadius: '20px',
            backgroundColor: 'rgb(254,254,254)',
          })
          customField.settings.required = true
          return customField
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Continue'
          Object.assign(customButton.styling, {
            color: 'rgb(254,254,254)',
            fontSize: '18px',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgb(0, 0, 0)',
            borderWidth: '0px',
            borderRadius: '0px',
            justifyContent: 'center',
            backgroundColor: 'rgb(24, 23, 26)',
          })
          customButton.settings.backBtn = false
          return customButton
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '20px' })
          return customSpacer
        })(),
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/mystery_ribbon_bottom.png'
          Object.assign(customImage.styling, {
            backgroundSize: 'cover',
            backgroundColor: 'rgba(230, 232, 229, 0)',
            backgroundPosition: 'center',
          })
          return customImage
        })(),
      ],
    },
    {
      id: 'sbxnbwb',
      contentItems: [
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/mystery_ribbon_top.png'
          Object.assign(customImage.styling, {
            backgroundSize: 'cover',
            backgroundColor: 'rgba(70, 88, 61, 0)',
            backgroundPosition: 'center',
          })
          return customImage
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '25px' })
          return customSpacer
        })(),
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/mystery_gift.png'
          Object.assign(customImage.styling,
            { backgroundSize: 'cover', backgroundPosition: 'center' })
          return customImage
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '10px' })
          return customSpacer
        })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'You\'re in!'
          Object.assign(customHeadline.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '32px',
            textAlign: 'center',
            fontFamily: 'Anton',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = '<p>Add [product] to your cart. When your total cart value exceeds $150, const [product] will be included as a complimentary gift!</p>'
          Object.assign(customText.styling, {
            color: 'rgb(24,23,26)',
            fontSize: '20px',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '14px' })
          return customSpacer
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Visit Product'
          Object.assign(customButton.styling, {
            color: 'rgb(254,254,254)',
            fontSize: '16px',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgb(0, 0, 0)',
            borderWidth: '2px',
            borderRadius: '0px',
            justifyContent: 'center',
            backgroundColor: 'rgb(24, 23, 26)',
          })
          customButton.settings.backBtn = false
          customButton.settings.action = 'reload'
          customButton.settings.href = '#'
          return customButton
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          Object.assign(customSpacer.styling, { padding: '30px' })
          return customSpacer
        })(),
        (() => {
          const customImage = JSON.parse(JSON.stringify(image))
          customImage.content.url = 'https://assets.onvocado.com/templates/mystery_ribbon_bottom.png'
          Object.assign(customImage.styling, {
            backgroundSize: 'cover',
            backgroundColor: 'rgba(230, 232, 229, 0)',
            backgroundPosition: 'center',
          })
          return customImage
        })(),
      ],
    },
  ],
}

export { json, info }
